import { Controller } from "@hotwired/stimulus"
import Shepherd from "shepherd.js"
import { offset } from "@floating-ui/dom"

export default class extends Controller {
  initialize() {
    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        cancelIcon: false,
        classes: "shepherd-demo-tour",
        scrollTo: { behavior: "smooth", block: "center" },
        floatingUIOptions: {
          middleware: [
            offset(35)
          ],
        },
        modalOverlayOpeningRadius: 6,
        modalOverlayOpeningPadding: 14,
        when: {
          show() {
            const currentStep = this.tour.getCurrentStep()
            const stepCount = this.tour.steps.length
            const progressElement = document.createElement("div")
            progressElement.classList.add("shepherd-progress")
            progressElement.textContent = `Step ${this.tour.steps.indexOf(currentStep) + 1} of ${stepCount}`

            const footer = this.getElement().querySelector(".shepherd-footer")
            footer && footer.prepend(progressElement)
          },
          hide() {
            const progressElement = this.getElement().querySelector(".shepherd-progress")
            progressElement && progressElement.remove()
          }
        }
      },
    })
    this.tour.addStep({
      title: "Security From Every Angle",
      text: "We've got you covered - protection for endpoints and identities, as well as correlation of all that data. Explore any product you want to see how we keep you secure.",
      attachTo: {
        element: "#product_left_nav_items",
        on: "right"
      },
      modalOverlayOpeningPadding: 0,
      buttons: [
        {
          action() {
            return this.next()
          },
          text: "Next",
          classes: "link-demo-sandbox-tour-step-1"
        }
      ],
    })
    this.tour.addStep({
      cancelIcon: { enabled: true },
      title: "Huntress Never Sleeps",
      text: "Our SOC team works 24/7/365 to keep you, your users, and your organization safe. We sift through all the noise, with single digit false positive rates. If there is an incident, we'll help you every step of the way.<br><br>View example reports on the <a class='underline' href='/account/infection_reports'>Incident Reports</a> page.",
      attachTo: {
        element: ".active-incidents",
        on: "bottom"
      },
      buttons: [
        {
          action() {
            return this.next()
          },
          text: "Close Tour",
          classes: "link-demo-sandbox-tour-step-2"
        }
      ]
    })
  }

  disconnect() {
    this.cancelTour()
  }

  startTour() {
    this.tour.start()
  }

  cancelTour() {
    this.tour.cancel()
  }

  click(e) {
    if (e.target.closest(".shepherd-modal-overlay-container")) {
      this.cancelTour()
    }
  }
}
